"use strict";
angular.module("channelManagementAddModule", []).
controller("channelManagementAddCtrl", ["$scope", "$modalInstance", "httpService", "channleId", 'modalDialog', function ($scope, $modalInstance, httpService, channleId, modalDialog) {
  initStatus();
  initData();
  /**
   * 初始数据
   */
  function initStatus() {
    $scope.status = {
      checkData: [], //渠道数据
    }
    $scope.data = {
      listData: [], //全选
      selectedArray: [] //多选
    }
  }
  /**
   * 初始状态
   */
  function initData() {
    requestData();
  }
  /**
   * 获取数据
   */
  function requestData() {
    httpService.http('/mcnadmin/admin/pgcuser/findUserChannels.do', {
      id: channleId
    }, 'post').then(function (res) {
        $scope.data.listData = $scope.status.checkData = res.data;
    })
  }
  /**
   * [selectDoc description] 单选
   * @param  {[type]} item [description] 当前数据
   * @return {[type]}      [description]
   */
  $scope.selectUser = function (item) {
    var index = $scope.data.selectedArray.indexOf(item);
    index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
  };
  /**
   * [selectPanel description] 全选当前面板的稿件
   * @param  {[type]} items [description] 当前面板
   * @return {[type]}       [description]
   */
  $scope.selectPanel = function (items) {
    if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
      $scope.data.selectedArray = [];
    } else {
      $scope.data.selectedArray = [].concat($scope.data.listData);
    }
  };
  /**
   * 确定
   */
  $scope.confirm = function () {
    // modalDialog.backConfirmModal("强制下线", "确认下线此文章？", function() {
    //   $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/downlineArticle.do", {articleId:docId,channelId:channelId}, "post").then(function(data) {
    //     modalDialog.alertType('','下线成功','success');
    //     requestData();
    //     });
    //   });
    if($scope.data.selectedArray.length==0)return;
    $modalInstance.dismiss();
    modalDialog.backConfirmModal('删除渠道', '确认删除选中渠道', function () {
      var str = '';
      for (var i = 0; i < $scope.data.selectedArray.length; i++) {
        if (i < $scope.data.selectedArray.length - 1) {
          str += $scope.data.selectedArray[i].channelId + ',';
        } else {
          str += $scope.data.selectedArray[i].channelId;
        }
      }
      httpService.http('/mcnadmin/admin/pgcuser/deleteUserChannels.do', {
        userId: channleId,
        channelIds: str
      }, 'post').then(function (res) {
        modalDialog.alertType('','删除成功','success');
      })
    })
    // $modalInstance.close($scope.userinfo);

    // $validation.validate($scope.createForm).success(function() {
    //     if($scope.status.t){
    //         $scope.userinfo.bankName = $scope.status.selectedBank.value;
    //         $modalInstance.close($scope.userinfo);
    //     }
    // }).error(function() {
    //     angular.invalidPosition($scope.createForm, $element);
    // });

  };
  /**
   * 取消
   */
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
}]);
